import gql from "graphql-tag";

export const MY_TIMESHEET_CREATE_PROJECT = gql`
  mutation createMySheetProject(
    $name: String!
    $description: String!
    $validFrom: Date
    $validTo: Date
  ) {
    createMySheetProject(
      name: $name
      description: $description
      validFrom: $validFrom
      validTo: $validTo
    ) {
      _id
      name
      description
      color
      validFrom
      validTo
      createdAt
      createdBy
      modifiedAt
      modifiedBy
      isDeleted
    }
  }
`;
